export default "__VITE_ASSET__BYv9r_ic__"